import { render, staticRenderFns } from "./molecule.patternMaker.stickerTabs.vue?vue&type=template&id=1cd1ee80"
import script from "./molecule.patternMaker.stickerTabs.vue?vue&type=script&lang=ts"
export * from "./molecule.patternMaker.stickerTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports